import {call, put} from 'redux-saga/effects';
import {receivePressReleasesData} from "../actions/pressReleasesActions";
import {fetchPressReleasesData} from "../api/fetchPressReleasesData";

export default function* getPressReleasesData(action) {
  try {
    const pressReleasesData = yield call(fetchPressReleasesData);
    yield put(receivePressReleasesData(pressReleasesData));
  } catch (e) {
    console.log(e)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/pressReleasesSaga.js